import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "correct-circle-icon",
  "aria-label": "Correct icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM16.0216 10.1361C16.3144 9.84321 16.3144 9.36834 16.0216 9.07544C15.7287 8.78255 15.2538 8.78255 14.9609 9.07544L10.6002 13.4362L8.97662 11.8126C8.68373 11.5197 8.20885 11.5197 7.91596 11.8126C7.62307 12.1055 7.62307 12.5804 7.91596 12.8732L10.0839 15.0411C10.3768 15.334 10.8516 15.334 11.1445 15.0411C11.1863 14.9993 11.2222 14.9538 11.2521 14.9056L16.0216 10.1361Z"
    }, null, -1)
  ])))
}
export default { render: render }